
import NoMatch from "./components/NoMatch";
import Drawings from "./components/files/Drawings";
import CreateProjectForm from "./components/projects/CreateProject";
import {Navigate, RouteObject} from "react-router-dom";
import AppLayout from "./App.layout";
import {lazy} from "react";
import CompanySetup from "./components/CompanySetup/CompanySetup";
import {whoAmIResponse} from "@models/project";
import UserProfile from "./components/admin/Profile";
import EditProject from "./components/developer/EditProject";
import OwnUserProfile from "./components/admin/OwnProfile";
import ProjectDirectoryView from "./components/directory/Directory";
import CompanyDirectoryView from "./components/admin/CompanyDirectory";
import CompanyBaseView from "./components/admin/CompanyBaseView";
import ProjectConfig from "./components/project_conf/ProjectConfig";
import ProjectMessage from "./components/messages/ProjectMessages";
import UserManagementView from "./components/admin/UserManagementView";
import QAPage from "./components/qa_forum/QAPage";
import QAThread from "./components/qa_forum/QAThread";
import BidSummary from "./components/bid/BidTableView";
import Docs from './components/admin/docs'
import BidChart from "./components/bid/BidChart";
import CompareBids from "./components/developer/compareBids";
import NotificationHome from "./components/notification/NotificationHome";
import {CompanyType} from "./models/company";
import GeneralProjectsInfo from "./components/projects/GeneralProjectsInfo";
import {ProjectProvider} from "./components/ProjectProvider";
import ViewProjectHomePage from "./components/projects/ProjectHomePage";
import HomePage from "./components/HomePage";
import VEHomePage from "./components/ve/veHome";
import {QlinkPageWithEmail} from "./components/qlink/quickLinkPageWithEmail";
import {BulkInvitePage} from "./components/bulkInvite/BulkInvitePage";
import {RootScopesListPage, RootScopeView} from "./components/scope/ScopesPage";
import {BidPage} from "./components/bid/BidPage";
import ScopeOverview from "./components/scope/developer/ScopeOverview";
import DeveloperScopesPage from "./components/scope/developer/ScopesListPage";
import CliAuthCallback from "./components/auth/CliAuthCallback";



function _nestedRoutes() {
    return [

        {
            path: "*",
            element: <NoMatch/>,
        },
         {
            path: "/",
            element: <HomePage/>,
        },
        {
            path: "auth/cli",
            element: <CliAuthCallback/>,
        },
        {
            path: "profile", // own user profile
            element: <OwnUserProfile/>,
        },
        {
            path: "profile/:user", // other user profiles
            element: <UserProfile/>,
        },
        /**
         *
         * */
        {
            path: "company/{company_id}", // view another company's profile
            element: <NoMatch/>,
        },
        {
            path: "/company", // own - company profile admin
            element: <CompanyBaseView/>,
        },
        {
            path: "company/directory",
            element: <CompanyDirectoryView/>,
        },
        {
            path: "company/profile",
            element: <CompanyDirectoryView/>,
        },
        {
            path: "company/project-config",
            element: <NoMatch/>,
        },
        {
            path: "company/manage/:user_id",
            element: <UserManagementView/>,
        },
        {
            path: "/project/create",
            element: <CreateProjectForm project={null} project_id={null}/>,
        },
        {
            path: 'project/:project_id',
            element: <ProjectProvider/>,
            children: [
                {
                    index: true,
                    element: <ViewProjectHomePage/>,
                },
                {
                    path: "edit",
                    element: <EditProject/>,
                },
                // bids ----------------------------------------------
                {
                    path: "bid/:bid_id",
                    element: <BidPage />,
                },
                {   // ok
                    path: "bidders",
                    element: <BidSummary/>, // <FindBidderView />,
                },
                {
                    path: "bidding/compare",
                    element: <CompareBids/>,
                },
                {
                    path: "bidding-chart",
                    element: <BidChart/>,
                },


                // VE ---------------------------------------------- DONE
                 {
                    path: "ve",
                    element: <VEHomePage/>,
                },
                {
                    //
                    path: "ve/:ve_id",
                    element: <VEHomePage/>,
                },
                // QA ---------------------------------------------- DONE
                {
                    path: "qa",
                    element: <QAPage creating={false}/>,
                },
                {
                    path: "qa/:qa_id",
                    element: <QAThread/>,
                },
                {
                    path: "qa/new",
                    element: <QAPage creating={true}/>,
                },
                //  ---------------------------------------------- OK
                {
                    path: "directory",
                    element: <ProjectDirectoryView/>,
                },
                {
                    path: "documents",
                    element: <Drawings/>,
                },
                {
                    path: "config",
                    element: <ProjectConfig/>,
                },
                {   // developer only - project email log
                    path: "messages",
                    element: <ProjectMessage/>,
                },
                //  SCOPES ----------------------------------------------
                {   // todo - ROLE SPECIFIC PAGES
                    path: "scopes",
                    element: <RootScopesListPage />,
                },
                {   // developer only - bid tab of ranked bids per scope. old link, scopes/ shows this now
                    path: "scopes/overview",
                    element: <ScopeOverview />,
                },
                {   // developer only - drag to reorder card list
                    path: "scope_cards",
                    element: <DeveloperScopesPage />,
                },
                {   // todo - ROLE SPECIFIC PAGES
                    path: "scopes/:scope_id",
                    element: <RootScopeView/>,
                },
            ]
        },
        {
            path: "/projects",
            element: <GeneralProjectsInfo/>,
        },
        {
            path: "notifications",
            element: <NotificationHome/>,
        },
        {
            path: "docs",
            element: <Docs/>,
        },
         {
                path: "qlink/:quid",
                element: <QlinkPageWithEmail/>
         },
         {
                path: "invite/:token",
                element: <BulkInvitePage/>
         }
    ];

}

function routeConstructor(role: whoAmIResponse) {
    if (role.company_type === CompanyType.builder
        || role.company_type === CompanyType.developer
        || role.company_type === CompanyType.broker
    ){
        return _nestedRoutes()
    } else if (role.company_type === CompanyType.not_set) {
        return [
            {
                path: "/*",
                element: (
                    <Navigate to="/company-setup" state={{whoAmI: role}}/>
                ),
            },
             {
                path: "/qlink/:quid",
                element: <QlinkPageWithEmail/>
             },
             {
                 path: "/invite/:token",
                 element: <BulkInvitePage/>
             },
            {
                path: "/company-setup",
                element: <CompanySetup/>,
            },

        ];
    } else {
        return [
            {
                path: "/qlink/:quid",
                element: <QlinkPageWithEmail/>
             },
            {
                path: "/invite/:token",
                element: <BulkInvitePage/>
            },
        ];
    }
}


const RouterBuilder = (userData: whoAmIResponse) => {
    const routes: RouteObject[] = [
        {
            element: <AppLayout role={userData}/>,
            children: routeConstructor(userData),
        },
    ];

    return routes;
};

export default RouterBuilder;

